<template>
  <el-row>
    <el-col style="padding-top: 6px;" :span="5">
      <el-row class="title-bar">
        <div class="title-h3 mr-r15">관리 그룹</div>
      </el-row>
      <div>
        <w-physical-tree class="mr-r30" ref="sideTree" managetype-id="NMS" @clickNode="onClickNode" @load="loadTreeData" style="overflow: hidden"></w-physical-tree>
      </div>
    </el-col>
    <el-col :span="19">
      <w-syslog-target-table :selected-node="selectedNode"></w-syslog-target-table>
    </el-col>
  </el-row>
</template>

<script>
import WPhysicalTree from '@/components/tree/DynamicPhysicalTree';
import WSyslogTargetTable from './components/SyslogTargetTable';

export default {
  name: 'WSyslogCollect',
  components: {
    WSyslogTargetTable,
    WPhysicalTree,
  },
  data() {
    return {
      selectedNode: {},
      nodeData: {},
    };
  },
  methods: {
    onClickNode(data) {
      this.selectedNode = data;
    },
    loadTreeData() {
      this.nodeData = this.$refs.sideTree.getTree();
      this.nodeData.setCurrentKey('NMS');
      this.selectedNode = this.nodeData.getCurrentNode();
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log/Syslog/SyslogCollect.vue